import ArtifactGroupType from "../base/ArtifactGroupType";


const HectorSword = {
  id: '141',
  name: "Hector's Sword",
  groupIcon: 'LegendsOfTroy',
  type: ArtifactGroupType.LEGENDS_OF_TROY,
  icon: 'SwordOfHector',
  power: 10
};

export default HectorSword;
